"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _compact = _interopRequireDefault(require("lodash/compact"));

var _compose = _interopRequireDefault(require("lodash/fp/compose"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _react = require("react");

var _constants = require("../../constants");

var _utils = require("../../utils");

var _utils2 = require("./utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toArray(arr) {
  return _arrayWithHoles(arr) || _iterableToArray(arr) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
  }

  if (enumerableOnly) keys = keys.filter(function (sym) {
    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
  });
  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function setWeekMatrixFlags(week, flagName, evaluator) {
  return week.map(function (displayDate) {
    if (displayDate) {
      return _objectSpread({}, displayDate, _defineProperty({}, flagName, evaluator(displayDate)));
    }

    return displayDate;
  });
}

function setDateMatrixFlags(dateMatrix, flagName, evaluator) {
  var newDateMatrix = dateMatrix.reduce(function (acc, curr) {
    return [].concat(_toConsumableArray(acc), [setWeekMatrixFlags(curr, flagName, evaluator)]);
  }, []);
  return newDateMatrix;
}

function setIsInSelectedRange(options) {
  var selected = options.selected,
      variant = options.variant;
  return function (dateMatrix) {
    var selectedDates = Array.isArray(selected) ? (0, _compact.default)(selected) : [];

    if (variant !== 'range' || selectedDates.length !== 2) {
      return dateMatrix;
    }

    return setDateMatrixFlags(dateMatrix, 'isInSelectedRange', function (displayDate) {
      return (0, _utils.isBetweenDates)(selectedDates[0], selectedDates[1], (0, _utils.buildJSDate)(displayDate));
    });
  };
}

function setIsInActiveRange(options) {
  var currentActiveDate = options.currentActiveDate,
      selected = options.selected,
      variant = options.variant;
  return function (dateMatrix) {
    var selectedDates = Array.isArray(selected) ? (0, _compact.default)(selected) : [];

    if ( // this only applies to the range variant
    variant !== 'range' || // there must be a current active date
    !currentActiveDate || // there must be _one_ and only _one_ selected date
    selectedDates.length !== 1) {
      return dateMatrix;
    }

    return setDateMatrixFlags(dateMatrix, 'isInActiveRange', function (displayDate) {
      var currentDisplayDate = (0, _utils.buildJSDate)(displayDate);
      /**
       * A date is considered within the active range if it is the first or last date,
       * or between the current active date and the selected date.
       */

      return (0, _utils.isSameDate)(currentDisplayDate, currentActiveDate) || (0, _utils.isSameDate)(currentDisplayDate, selectedDates[0]) || (0, _utils.isBetweenDates)(currentActiveDate, selectedDates[0], currentDisplayDate) || (0, _utils.isBetweenDates)(selectedDates[0], currentActiveDate, currentDisplayDate);
    });
  };
}

function setIsSelected(options) {
  var selected = options.selected,
      variant = options.variant;
  return function (dateMatrix) {
    if ( // there must be a selected value
    !selected || // if selected is an array, it must not be empty
    Array.isArray(selected) && (0, _isEmpty.default)((0, _compact.default)(selected))) {
      return dateMatrix;
    }

    return setDateMatrixFlags(dateMatrix, 'isSelected', function (displayDate) {
      var currentDisplayDate = (0, _utils.buildJSDate)(displayDate);

      if (variant === 'range') {
        return (0, _utils.isSameDate)(currentDisplayDate, selected[0]) || (0, _utils.isSameDate)(currentDisplayDate, selected[1]);
      }

      return (0, _utils.isSameDate)(currentDisplayDate, selected);
    });
  };
}

function setIsToday(options) {
  var today = options.today;
  return function (dateMatrix) {
    return setDateMatrixFlags(dateMatrix, 'isToday', function (displayDate) {
      return (0, _utils.isSameDate)((0, _utils.buildJSDate)(displayDate), today);
    });
  };
}

function setIsDisabled(options) {
  var disabledDateRules = options.disabledDateRules;
  return function (dateMatrix) {
    if ( // there must be an array of rules
    !disabledDateRules || // it must not be empty
    (0, _isEmpty.default)((0, _compact.default)(disabledDateRules))) {
      return dateMatrix;
    }

    return setDateMatrixFlags(dateMatrix, 'isDisabled', function (displayDate) {
      var currentDisplayDate = (0, _utils.buildJSDate)(displayDate);
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = disabledDateRules[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _step$value = _toArray(_step.value),
              type = _step$value[0],
              params = _step$value.slice(1);

          switch (type) {
            case _constants.DisabledDateRuleName.AFTER:
              if ((0, _utils.isAfterDate)(params[0], currentDisplayDate)) return true;
              break;

            case _constants.DisabledDateRuleName.BEFORE:
              if ((0, _utils.isBeforeDate)(params[0], currentDisplayDate)) return true;
              break;

            case _constants.DisabledDateRuleName.BETWEEN:
              if ((0, _utils.isBetweenDates)(params[0], params[1], currentDisplayDate)) return true;
              break;

            case _constants.DisabledDateRuleName.IS:
              if ((0, _utils.isSameDate)(currentDisplayDate, params[0])) return true;
              break;

            case _constants.DisabledDateRuleName.IS_DAY_OF_WEEK:
              if (currentDisplayDate.getDay() === params[0]) return true;
              break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return false;
    });
  };
}

function useMonth(options) {
  var optionValues = Object.values(options);
  return (0, _react.useMemo)(function () {
    var displayMonth = (0, _utils2.buildDisplayMonth)(options.date);
    var dateMatrix = (0, _compose.default)(setIsInSelectedRange(options), setIsInActiveRange(options), setIsSelected(options), setIsToday({
      today: new Date()
    }), setIsDisabled(options))((0, _utils2.buildDateMatrix)(displayMonth));
    return {
      dateMatrix: dateMatrix,
      displayMonth: displayMonth
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, _toConsumableArray(optionValues));
}

var _default = useMonth;
exports.default = _default;